import { defineComponent as r, createBlock as n, openBlock as c, unref as p, mergeProps as a, withCtx as m, createElementVNode as l } from "vue";
import { RevIcon as u } from "@ds/components/Icon";
const f = /* @__PURE__ */ r({
  name: "IconComputerMouse",
  __name: "IconComputerMouse",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(o) {
    const t = o;
    return (s, e) => (c(), n(p(u), a(t, { "view-box": "0 0 24 24" }), {
      default: m(() => [...e[0] || (e[0] = [
        l("path", {
          "fill-rule": "evenodd",
          d: "M9.458 2.25h5.085c.885 0 1.522-.001 2.058.192A3.25 3.25 0 0 1 18.558 4.4c.193.536.193 1.174.192 2.058V15a6.75 6.75 0 0 1-13.5 0V6.457c0-.884 0-1.522.192-2.058A3.25 3.25 0 0 1 7.4 2.442C7.936 2.25 8.573 2.25 9.458 2.25M9.6 3.75c-1.089 0-1.436.011-1.693.103a1.75 1.75 0 0 0-1.053 1.054C6.76 5.164 6.75 5.511 6.75 6.6v1.65h4.5v-4.5H9.6m3.15 4.5h4.5V6.6c0-1.089-.011-1.436-.103-1.693a1.75 1.75 0 0 0-1.054-1.054C15.837 3.761 15.489 3.75 14.4 3.75h-1.65v4.5m4.5 1.5H6.75V15a5.25 5.25 0 1 0 10.5 0V9.75",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  f as default
};
